import * as React from "react"
import * as Sentry from "@sentry/browser"
import { Button } from "reactstrap"

class ErrorBoundary extends React.Component {
	state = {
		hasError: false,
		eventId: null,
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, errorInfo) {
		Sentry.withScope((scope) => {
			scope.setExtras(errorInfo)
			const eventId = Sentry.captureException(error)
			this.setState({ eventId })
		})
	}

	render() {
		if (this.state.hasError) {
			//render fallback UI
			return (
				<>
					<h1>متاسفانه مشکلی پیش آمده</h1>
					<Button
						color="success"
						onClick={() =>
							Sentry.showReportDialog({
								eventId: this.state.eventId,
							})
						}
					>
						گزارش خطا
					</Button>
				</>
			)
		}

		//when there's not an error, render children untouched
		return this.props.children
	}
}

export default ErrorBoundary
